import { Button } from "@design-system/Inputs/Button";
import { Modal } from "@design-system/Modal";
import { type FC } from "react";
import { type TChartData } from "./CompletionChart";
import { useQuestionnaireStatsTranslations } from "./i18n";
import { UsersActivityChart } from "./UsersActivityChart";

export const UsersActivityModal: FC<{
    chartData: TChartData;
}> = ({ chartData }) => {
    const { t, keys } = useQuestionnaireStatsTranslations();
    return (
        <Modal>
            <Modal.Trigger asChild>
                <Button className="w-fit" size="sm" variant="textLink">
                    {t(keys.users_activity_modal_trigger_button_label, {
                        count: chartData.dataRows.length,
                    })}
                </Button>
            </Modal.Trigger>
            <Modal.Overlay>
                <Modal.Content>
                    <Modal.Header>
                        <Modal.Title>
                            {t(keys.users_activity_modal_title)}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <UsersActivityChart chartData={chartData} />
                    </Modal.Body>
                    <Modal.Footer>
                        <Modal.ConfirmCTA>
                            {t(keys.users_activity_modal_close_cta)}
                        </Modal.ConfirmCTA>
                    </Modal.Footer>
                </Modal.Content>
            </Modal.Overlay>
        </Modal>
    );
};
